import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import "leaflet/dist/leaflet.css";
import Recap from "@/pages/Recap";
import CommunesMap from "@/pages/CommunesMap";
import Settings from "@/pages/Settings";
import { AccessGate } from "@/components/AccessGate";
import Layout from "@/components/Layout";
import { EventDrawerProvider } from "@/components/EventDrawer";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";
import Events from "@/pages/Events";
import CalendarView from "@/pages/CalendarView";
import MapView from "@/pages/MapView";
import Communes from "@/pages/Communes";
import Sources from "@/pages/Sources";
import { Organizers, Venues } from "@/pages/Entities";
import Signals from "@/pages/Signals";
import Alerts from "@/pages/Alerts";
import TechLog from "@/pages/TechLog";

export default function App() {
  return (
    <BrowserRouter>
      <AccessGate>
      <EventDrawerProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/evenements" element={<Events />} />
            <Route path="/calendrier" element={<CalendarView />} />
            <Route path="/carte" element={<MapView />} />
            <Route path="/carte-territoire" element={<CommunesMap />} />
            <Route path="/communes" element={<Communes />} />
            <Route path="/sources" element={<Sources />} />
            <Route path="/organisateurs" element={<Organizers />} />
            <Route path="/lieux" element={<Venues />} />
            <Route path="/signaux" element={<Signals />} />
            <Route path="/alertes" element={<Alerts />} />
            <Route path="/journal" element={<TechLog />} />
            <Route path="/recap" element={<Recap />} />
            <Route path="/parametres" element={<Settings />} />
          </Route>
        </Routes>
      </EventDrawerProvider>
      </AccessGate>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}
